export default __webpack_public_path__ + "static/20240628-f6e23963c552f4528d3cdf36cdd8b5de.png";